/**
 * Calculate the number of pages filled in the book
 */

interface AnswerLike {
  text: string;
  [key: string]: any;
}

export const calculatePagesFilled = (
  answers: Record<string | number, AnswerLike>,
  photosCount: number
): number => {
  const charsPerPage = 250;
  const initialPages = 8;

  const pageCounts = Object.values(answers).reduce((total, val) => {
    const answerLength = (val.text || '').replaceAll(' ', '').length;
    return total + Math.ceil(answerLength / charsPerPage);
  }, 0);

  return initialPages + pageCounts + photosCount;
};

export const getPageMotivation = (pages: number): { level: number; text: string } => {
  if (pages >= 200) {
    return {
      level: 5,
      text: `Уже ${pages} страниц! Твоему получателю можно лишь позавидовать`,
    };
  }
  if (pages >= 141) {
    return {
      level: 4,
      text: `Финальный рывок — ${pages} страниц! Совсем скоро книга будет готова`,
    };
  }
  if (pages >= 81) {
    return {
      level: 3,
      text: `${pages} страниц позади! Больше половины пути`,
    };
  }
  if (pages >= 41) {
    return {
      level: 2,
      text: `Отличный темп — ${pages} страниц!`,
    };
  }
  return {
    level: 1,
    text: `${pages} страниц — начало положено!`,
  };
};
